import { createSlice } from '@reduxjs/toolkit';
import { patientApi } from 'store/services/patient';

const initialState = {
    patients: {
        active: [],
        locations: [],
        search: ''
    },
    patientPage: {
        page: 1
    },
    locations: {
        search: '',
        locationType: [],
        status: []
    },
    locationPage: {
        page: 1
    },
    employee: {
        search: '',
        role_id: [],
        service_id: [],
        active: [],
        license: []
    },
    employeePage: {
        page: 1
    }
};

const slice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        setPatientFilter(state, action) {
            state.patients = action.payload;
        },
        setPatientPage(state, action) {
            state.patientPage = action.payload;
        },
        setLocationFilter(state, action) {
            state.locations = action.payload;
        },
        setLocationPage(state, action) {
            state.locationPage = action.payload;
        },
        setEmployeeFilter(state, action) {
            state.employee = action.payload;
        },
        setEmployeePage(state, action) {
            state.employeePage = action.payload;
        }
    }
});

export default slice.reducer;
export const { setPatientFilter, setLocationFilter, setEmployeeFilter, setPatientPage, setLocationPage,setEmployeePage } = slice.actions;
